import { Link } from "@tanstack/react-router";

import { BrandLogo } from "@/components/brand-logo";
import { SocialProfiles } from "@/components/social-profiles";
import { CRUKS_NAV, FOOTER_METHODS, FOOTER_NAV, SITE } from "@/lib/site";

export function SiteFooter() {
  return (
    <footer className="cv-auto border-t border-border bg-primary text-primary-foreground">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div>
            <div className="flex items-center gap-2 font-bold">
              <BrandLogo className="h-9 w-9" inverted />
              {SITE.name}
            </div>
            <p className="mt-3 text-sm text-primary-foreground/80">{SITE.tagline}.</p>
            <p className="mt-4 inline-flex items-center rounded-md border border-primary-foreground/30 px-2.5 py-1 text-xs font-semibold">
              18+
            </p>
            <SocialProfiles />
          </div>
          {FOOTER_NAV.map((group) => (
            <nav key={group.title} aria-label={group.title}>
              <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-primary-foreground/70">
                {group.title}
              </p>
              <ul className="space-y-1.5">
                {group.links.map((link) => (
                  <li key={link.href}>
                    {link.href.startsWith("http") ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="text-sm text-primary-foreground/85 transition-colors hover:text-primary-foreground"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-sm text-primary-foreground/85 transition-colors hover:text-primary-foreground"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <nav aria-label="Betaalmethoden" className="mt-10 border-t border-primary-foreground/15 pt-6">
          <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-primary-foreground/70">
            Betaalmethoden
          </p>
          <ul className="flex flex-wrap gap-x-4 gap-y-1.5">
            {FOOTER_METHODS.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className="text-sm text-primary-foreground/85 transition-colors hover:text-primary-foreground"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="mt-8 border-t border-primary-foreground/15 pt-6">
          <p className="mb-3 text-sm text-primary-foreground/85">
            Kom je sites tegen die reclame maken met spelen buiten het register? Lees eerst wat een{" "}
            <Link to={CRUKS_NAV.href} className="font-medium underline underline-offset-2">
              casino zonder Cruks
            </Link>{" "}
            in de praktijk betekent. Hulp nodig? Neem contact op met{" "}
            <a href="https://www.loketkansspel.nl" target="_blank" rel="nofollow noopener noreferrer" className="underline underline-offset-2">
              Loket Kansspel
            </a>{" "}
            of kijk op{" "}
            <a href="https://www.cruks.nl" target="_blank" rel="nofollow noopener noreferrer" className="underline underline-offset-2">
              cruks.nl
            </a>
            .
          </p>
          <p className="text-xs leading-relaxed text-primary-foreground/70">{SITE.disclaimer}</p>
          <address className="mt-3 text-xs not-italic leading-relaxed text-primary-foreground/70">
            {SITE.name} · {SITE.address.street}, {SITE.address.postalCode} {SITE.address.city},{" "}
            {SITE.address.country}
          </address>
          <p className="mt-3 text-xs text-primary-foreground/60">
            © {new Date().getFullYear()} {SITE.domain}. Alle rechten voorbehouden.
          </p>
        </div>
      </div>
    </footer>
  );
}
